var portfolioList = {
	label: {
		caption: "Portfolio-lijst",
		name: "Portfolio",
		currency: "Valuta",
		numberOfPositions: "Posities",
		numberOfTransactions: "Transacties",
		actions: "Acties"
	},
	noPortfolios: {
		title: "Info",
		message: "Er is nog geen portfolio aangemaakt. Klik op de knop \"Portfolio Toevoegen\" en vul het formulier in om een portfolio aan te maken."
	},
	error: {
		title: "Er is een fout opgetreden.",
		portfolioLimitExceeded: "Portfolio-limiet overschreden."
	},
	createPortfolioAction: "Portfolio Toevoegen",
	editPortfolioAction: "Portfolio Bewerken",
	deletePortfolioAction: "Portfolio Verwijderen",
	showActions: "Toon acties"
};
var nl = {
	portfolioList: portfolioList
};

export { nl as default, portfolioList };
